<div *ngIf="showLabel" class="label">
  {{ environmentFrontend }}
  <a class="btn-close" (click)="close()">
    <yat-icon id="057cee7c-d0f0-4d83-8065-37f72b3ed917" name="cross"></yat-icon>
  </a>
</div>
